<template>
    <div class="imgCover">
        <div class="previewImg">
            <i class="fa fa-image"></i>
        </div>
    </div>
</template>
<script>
export default {
    name: "imgCover",
    props: {
        imgUrl: {
            type: String,
            required: false,
            default: ''
        },
    },
}
</script>
<style lang="scss" scoped>
.imgCover {
    position: relative;
}
.previewImg {
    max-width: 150px;
    width: 95%;
    overflow: hidden;
    height: 50px;
    display: flex;
    margin: auto;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 0 solid #aeaeae;
}
.previewImg .fa-image{
    font-size: 50px;
    color: #aeaeae;
}

.previewImg img {
    width: 100%;
    height: 100px;
    object-fit: cover;
    margin-left: 0px
}
.previewImg:hover .fa-image{
    color: #6a7a8c;
    cursor: pointer;
}
</style>
